<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header-top" style="height: 50px;">
				<s-header-top></s-header-top>
			</el-header>
			<el-header class="header">
				<s-header></s-header>
			</el-header>
			<el-main>				
				<div class="content">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<span style="float: left;">当前位置：</span>
						<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/activity' }">双创活动</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/activityDetail' }">详情</el-breadcrumb-item>
					</el-breadcrumb>
						
					<div class="page">
						<div class="page_body">
							<el-row class="detail_info">
								<el-col :span="8" class="detail_info_image">
									<el-image style="width: 100%; height: 100%" :src="item.actImg?imgPath(item.actImg) : require('../../static/pro.jpg')" fit="contain"></el-image>
								</el-col>
								<el-col :span="16" class="detail_info_mark">
									<el-row class="name mar_bottom10">
										<el-col :span="24">
											{{item.actTitle}}
										</el-col>
									</el-row>
									<!-- <el-row class="font_grey mar_bottom5">
										<el-col :span="24">
											主办人：{{item.actHost}}
										</el-col>
									</el-row> -->
									<el-row class="font_grey mar_bottom5">
										<el-col :span="24">
											活动时间：{{item.actBegintime}}
										</el-col>
									</el-row>
									<el-row class="font_grey mar_bottom5">
										<el-col :span="24">
											活动地点：{{item.actAddress}}
										</el-col>												
									</el-row>
									<el-row class="font_grey mar_bottom5">
										<el-col :span="24">
											报名截止时间：{{item.actEnrollendtime}}
										</el-col>												
									</el-row>
									<el-row class="font_grey mar_bottom">
										<el-col :span="24">
											联系电话：{{item.actTelephone}}
										</el-col>
									</el-row>
									<el-row class="buttons" type="flex">
										<template v-if="item.actType!='2'">
											<div class="enter_close" v-if="item.actEnrollendtime < currentDate">报名结束</div>
											<div class="enter" v-else @click="openDialog()">我要报名</div>
										</template>
										<div class="call" @click="call(item.actTelephone)"><i class="el-icon-chat-dot-round"></i>我要咨询</div>
									</el-row>
								</el-col>
							</el-row>
							<el-row class="contact mar_bottom">
								<el-col :span="24">
									<el-row class="remark  mar_bottom">
										<el-col :span="24" class="lab_hr">
											<div class="lab mar_bottom10" v-if="item.actType == '1'">活动通知</div>
											<div class="lab mar_bottom10" v-else-if="item.actType == '2'">活动回顾</div>
										</el-col>
										<el-col :span="24">
											<p v-html='item.actInfo'></p>
										</el-col>
									</el-row>
								</el-col>
							</el-row>
						</div>
					</div>
					<!-- 活动报名dialog -->
					<el-dialog title="活动报名" :visible.sync="dialogVisible">
						<!-- 二维码dialog -->
						<el-dialog title="扫码支付" :visible.sync="payDialogVisible" width="30%" append-to-body>
							<span style="text-align: center;display: block;"><img style="width: 340px;height: 340px;" :src="QRcode" /></span>
							<span style="text-align: center;display: block;margin-top: 10px;">扫码支付{{ item.money }}元</span>
							<span slot="footer" class="dialog-footer">
								<el-button @click="payDialogVisible = false">取 消</el-button>
								<el-button @click="toOrder()">已支付</el-button>
							</span>
						</el-dialog>
						<!-- 输入金额表单 -->
						<el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
							<el-form-item label="姓名" prop="name"><el-input v-model="form.name" autocomplete="off"></el-input></el-form-item>
							<el-form-item label="电话" prop="telephone"><el-input v-model="form.telephone" autocomplete="off"></el-input></el-form-item>
						</el-form>
						<div slot="footer" class="dialog-footer">
							<el-button @click="dialogVisible = false">取 消</el-button>
							<el-button type="primary" @click="signActivity()">确 定</el-button>
						</div>
					</el-dialog>
				</div>
			</el-main>
			<el-footer class="footer">
				<s-footer></s-footer>
			</el-footer>
			<el-footer class="copy-right">
				<s-copyRight></s-copyRight>
			</el-footer>
		</el-scrollbar>		
	</el-container>	
</template>

<script>
import sHeaderTop from '@/components/header_top'
import sHeader from '@/components/header'
import sFooter from '@/components/footer'
import sCopyRight from '@/components/copy-right'
import { activityDetail,signActivity } from '@/api';
export default {
	name: 'activityDetail',
	components:{
		sHeaderTop,
		sHeader,
		sFooter,
		sCopyRight
	},
	data () {
		var validateTel = (rule, value, callback) => {
			if (!value) {
			  return callback(new Error('手机号不能为空'));
			} else  if (!/^1(3|4|5|6|7|8)\d{9}$/.test(value)) {
				return callback(new Error('请输入正确的手机号'));
			} else {
				callback();
			}
		};
		const currentDate = this.getDate({
		  	format: true
		})
		return {
			dialogVisible: false,//活动报名dialog
			currentDate: currentDate,
			id: '',//当前活动id
			item: null,//当前活动
			form:{
				activityID: '',
				name: '',
				telephone: '',
				type:'PC'
			},
			rules: {
				name: [
					{ required: true, message: '请输入姓名', trigger: 'blur' }
				],
				telephone: [
					{ required: true,validator: validateTel, trigger: 'blur' }
				]
			},
			payDialogVisible: false, //微信二维码支付dialog
			QRcode: '', //支付二维码
			orderId: '', //支付订单号
		}
	},
	mounted(option) {
		this.id = this.$route.query.id,  //接受参数关键代码
		this.getActivityDetail(this.id)
		this.form.activityID = this.id
	}, 
	methods: {
		//查询活动详情
		getActivityDetail(id){
			let _this = this
			activityDetail({
				id: id
			}).then(res=> {
				_this.item = res.data
			})
		},	
		//点击我要报名，弹出报名录入信息窗口
		openDialog() {
			this.dialogVisible = true;
		},
		//报名信息提交
		signActivity(){
			let _this = this
			_this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					signActivity(_this.form).then(res=> {
						if(res.code == 0){
							if(item.actPrice == '' || item.actPrice == '0' || item.actPrice == '0.00'){
								this.$message('报名成功');
								this.getActivityList()
								this.dialogVisible = false
							}else{
								//需支付活动
								//报名信息提交成功，弹出支付窗口
								_this.payDialogVisible = true;
								_this.QRcode = _this.$imgBaseUrl + res.data.imgUrl;
								_this.orderId = res.data.orderNo;
								_this.money = _this.item.actPrice;
							}
						}
					})
				}
			})
		},
		//支付完成，跳转至订单页面
		toOrder() {
			let routeUrl = this.$router.resolve({
				path: '/activityOrderDetail', //跳转的路径
				query: {
					//路由传参时push和query搭配使用 ，作用时传递参数
					id: this.orderId
				}
			});
			window.open(routeUrl.href, '_blank');
		},
		//打电话弹框
		call(phone){
			this.$alert( (phone)?phone:'暂未提供','咨询热线', {
				confirmButtonText: '确定',
				callback: action => {
				}
			});
		},
		//图片地址
		imgPath(oldPath){			
			return this.$imgBaseUrl + oldPath
		},
		getDate(type) {
			const date = new Date();
			const seperator1 = "-";
			const seperator2 = ":";
			//以下代码依次是获取当前时间的年月日时分秒
			let year = date.getFullYear();
			let month = date.getMonth() + 1;
			let strDate = date.getDate();
			let minute = date.getMinutes();
			let hour = date.getHours();
			let second = date.getSeconds();
			//固定时间格式
			if (month >= 1 && month <= 9) {
			month = "0" + month;
			}
			if (strDate >= 0 && strDate <= 9) {
			strDate = "0" + strDate;
			}
			if (hour >= 0 && hour <= 9) {
			  hour = "0" + hour;
			}
			if (minute >= 0 && minute <= 9) {
			  minute = "0" + minute;
			}
			if (second >= 0 && second <= 9) {
			  second = "0" + second;
			}
			let currentdate =  year + seperator1 + month + seperator1 + strDate 
							+ " " + hour + seperator2 + minute + seperator2 + second;
			return currentdate;
		},
	}
}
</script>

<style lang="scss" scoped>

.page_body{
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}


.detail_info_image,.detail_info_mark{
	height: 300px;
}

.name{
	line-height: 50px;
	// height: 50px;
	font-size: 18px;
	color: rgba(16, 16, 16, 1);
}

.enter,.enter_close{
	height: 36px;
	width: 120px;
	line-height: 36px;
	text-align: center;
	background-color: #999999;
	color: #FFFFFF;
	margin-right: 30px;
	border-radius: 4px;
}
.enter{
	background-color: #e6a23c;
	cursor: pointer;
}
.call{
	height: 36px;
	width: 120px;
	background-color: #F5F5F5;
	border: 1px solid #BBBBBB;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	margin-right: 30px;
	cursor: pointer;
}
.remark{
	width: 100%;
	>>> img{
		width:100%;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/activity-detail.vue